import type { DealProductBuilderRow, OptionDealProductBuilderRow } from '@src/types/OTC/otcProductBuilderTypes';
import { otcOptionFieldDefinitions } from '@src/utils/OTC/otcOptionFieldDefinitions';
import { getColumnTitle, getColumnTooltip } from '@src/utils/fieldDefinitionUtils';
import type { useDisclosureWithContext } from '@talos/kyoko';
import { useMemo } from 'react';
import { useDealProductBuilderAssets } from '../DealProductBuilderAssetsProvider';
import type { DealProductBuilderColumn } from '../dealProductBuilderColDef';
import { DealProductBuilderGrid } from './DealProductBuilderGrid';
import { buildCurrencySelectorColumn, buildOptionTypeSelectorColumn } from './baseProductBuilderColumns';

interface OptionProductBuilderGridProps {
  panelID: string;
  productDetailsDisclosure: ReturnType<
    typeof useDisclosureWithContext<{ rowIndex: number; rowData: DealProductBuilderRow }>
  >;
}

export const OptionProductBuilderGrid = ({ panelID, productDetailsDisclosure }: OptionProductBuilderGridProps) => {
  const { availableUnderlyingAssets } = useDealProductBuilderAssets();

  const customColumns = useMemo(() => {
    return [
      buildCurrencySelectorColumn<OptionDealProductBuilderRow>({
        key: 'baseAsset',
        headerName: getColumnTitle(otcOptionFieldDefinitions.underlying),
        currenciesToInclude: availableUnderlyingAssets,
        description: getColumnTooltip(otcOptionFieldDefinitions.underlying),
      }),
      buildOptionTypeSelectorColumn({
        headerName: getColumnTitle(otcOptionFieldDefinitions.optionType),
        description: getColumnTooltip(otcOptionFieldDefinitions.optionType),
      }),
    ] as DealProductBuilderColumn[];
  }, [availableUnderlyingAssets]);

  return (
    <DealProductBuilderGrid
      panelID={panelID}
      productDetailsDisclosure={productDetailsDisclosure}
      customColumnDefs={customColumns}
      fieldDefinitions={otcOptionFieldDefinitions}
    />
  );
};
